// src/Firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

// ✅ Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCF10DZFnzzcAgeawRKY-L8JKuDpGxqv2w",
  authDomain: "stellaris-123.firebaseapp.com",
  projectId: "stellaris-123",
  storageBucket: "stellaris-123.firebasestorage.app",
  messagingSenderId: "91000371319",
  appId: "1:91000371319:web:0070c2299838b1d232ae72",
  measurementId: "G-ZK7QG9TDPS"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Initialize Auth
const auth = getAuth(app);

// ✅ Better Analytics initialization
const initializeAnalytics = () => {
  return isSupported().then((yes) => {
    return yes ? getAnalytics(app) : null;
  });
};

// ✅ Export everything needed
export { 
  app, 
  auth, 
  initializeAnalytics, 
  RecaptchaVerifier, 
  signInWithPhoneNumber 
};